import type { DupeInputType } from '~/src/hooks/useGetDupes'

/**
 * Entry modality derived from a stored result row's `source`.
 *
 * Mirrors the server's `resolveDupeInputType` (`apps/api/src/lib/dupes/shared.ts`),
 * which reads the same `results.source` column as its FIRST and strongest signal.
 *
 * Why a client-side copy exists at all: the authoritative value arrives on the
 * dupes response, but the "also search" broadcast redirect is built once, early
 * — `useRedirectUrl` early-returns on an existing `redirectLink`, and forcing a
 * rebuild would write a second `link_clicks` row. So a modality that resolves
 * later never lands. `resultData.source` is available synchronously, which makes
 * it a usable FALLBACK behind the server value (DUP-2139).
 *
 * ⚠️ Returns undefined for anything else — notably `'extension'`, the third live
 * value. The server does not classify that from `source` either; it falls
 * through to the request shape, which the client cannot see. Undefined is the
 * honest answer: a null `input_type` means "unclassified", and guessing here
 * would write a wrong modality onto the commission-joining table.
 */
export function inputTypeFromResultSource(
  source: string | null | undefined
): DupeInputType | undefined {
  if (source === 'product-url') return 'url'
  if (source === 'image-url') return 'image'
  return undefined
}
